var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pfol__history" },
    [
      _vm._l(_vm.completedPostFitouts, function (item, index) {
        return _c(
          "HKLLeftRight",
          { key: index, staticClass: "pfol__history-item align-middle" },
          [
            _c(
              "div",
              {
                staticClass: "pfol__history-title",
                on: {
                  click: function () {
                    return _vm.previewHistory(item)
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("tenantProjects.postFitout.title")) +
                    " " +
                    _vm._s(item.number) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("HKLGrayHint", [
              _vm._v("\n      " + _vm._s(item.TipWording) + "\n    "),
            ]),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("PostFitOutPreviewSendModal", { ref: "previewSendModal" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }